<template>
    <section>
        <o-breadcrumb>
            <o-breadcrumb-item disabled> Home </o-breadcrumb-item>
            <o-breadcrumb-item href="/"> Docs </o-breadcrumb-item>
            <o-breadcrumb-item href="/components/Breadcrumb.html" active>
                Breadcrumb
            </o-breadcrumb-item>
        </o-breadcrumb>
    </section>
</template>
